export class TemplateChoiceTypeInput {
    description = '';
    constructor(templateChoiceType) {
        if (templateChoiceType) {
            this.description = templateChoiceType.description;
        }
    }
}
